import { ListItem, ListItemContent } from '@/components/elements/lists';
import Icon from '@/components/icons/Icon';
import { CampaignProduct } from '@/types/state/shared';

const PickedProduct = ({ product }: { product: CampaignProduct }) => {
  const { originalPriceLabel, priceLabel } = product;

  return (
    <ListItem leftPadding={false} rightPadding={false} leftSlot={<Icon variant="product" />}>
      <ListItemContent
        content={
          <>
            {originalPriceLabel && (
              <span className="text-danger-500">
                {priceLabel} <span className="text-black-600 line-through">({originalPriceLabel})</span>
              </span>
            )}
            {!originalPriceLabel && priceLabel}
          </>
        }
        contentClassName="text-m"
        subTitle={product.name}
        subTitleClassName="text-black-900 text-m font-semibold"
      />
    </ListItem>
  );
};

export default PickedProduct;
